import type { WorkoutLibraryRow } from '../types/library';

/**
 * Server list is the source of truth for library rows. Do not merge in stale `prev` rows that the server
 * omitted (e.g. after delete) — that previously resurrected deleted workouts.
 *
 * If the server returns zero workouts, trust it: do not keep stale rows from sessionStorage/React state
 * (e.g. after DB reset) — that caused ghost library cards with empty detail views.
 */
export function mergeWorkoutLibraryRowsFromServer(
  fromServer: WorkoutLibraryRow[],
  _prev: WorkoutLibraryRow[],
  _trainerId: string,
): WorkoutLibraryRow[] {
  if (fromServer.length === 0) {
    return [];
  }
  return [...fromServer].sort((a, b) => {
    const ta = a.createdAt ? new Date(a.createdAt).getTime() : 0;
    const tb = b.createdAt ? new Date(b.createdAt).getTime() : 0;
    return tb - ta;
  });
}
